import * as React from 'react';
import { Entity } from './Entity';
import { Checkbox, TableCell } from '@mui/material';
import TableCells from './TableCells';
import { TableRow as MuiTableRow } from '@mui/material';
import { ColumnDefinition } from './ColumnDefinition';

interface TableRowProps<T> {
  item: T;
  selected: boolean;
  handleClick: (event: React.MouseEvent<unknown>, id: number) => void;
  columnDefinitions: ColumnDefinition<T>[];
}

const TableRow = <T extends Entity>(
  props: React.PropsWithChildren<TableRowProps<T>>
) => {
  const { item, selected, handleClick, columnDefinitions } = props;

  return (
    <MuiTableRow key={props.item.id}>
      <TableCell padding="checkbox" sx={{ cursor: 'default' }}>
        <Checkbox
          size="small"
          sx={{ cursor: 'default', width: 28 }}
          checked={selected}
          onClick={(event) => handleClick(event, props.item.id)}
        />
      </TableCell>
      <TableCells row={item} columnDefinitions={columnDefinitions} />
    </MuiTableRow>
  );
};

export default TableRow;
